import { Typography, Image, Flex, Card, Radio } from "antd"
import AuthDesign from "../../components/AuthDesign/AuthDesign"
import Logo from "../../assets/images/auth-logo.png";
import { useState } from "react";
import CustomButton from "../../components/CustomButton/Button";
import { BTN_TXT } from "../../constants/constants";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/CustomButton/BackButton";
import {
    PRODUCT_GROUPS,
    PRODUCT_GROUP_OPTIONS,
    getDealCategoryDisplayName,
} from "../../helpers/dealCategoryProducts";

const { Title, Text } = Typography

const EnrollAs = () => {
    const [expandedGroup, setExpandedGroup] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const navigate = useNavigate()

    const handleParentSelect = (option) => {
        if (option.requiresSubCategory) {
            setExpandedGroup(option.key);
            // Keep current financing child if already chosen; otherwise clear
            if (selectedOption?.productGroup !== option.key) {
                setSelectedOption(null);
            }
            return;
        }

        setExpandedGroup(null);
        setSelectedOption({
            productGroup: option.key,
            label: option.label,
            dealCategoryId: option.dealCategoryId,
            dealCategoryName: option.label,
        });
    };

    const handleChildSelect = (parent, child) => {
        setExpandedGroup(parent.key);
        setSelectedOption({
            productGroup: parent.key,
            label: getDealCategoryDisplayName(child.dealCategoryId, child.label),
            dealCategoryId: child.dealCategoryId,
            dealCategoryName: getDealCategoryDisplayName(
                child.dealCategoryId,
                child.label,
            ),
            subCategoryLabel: child.label,
        });
    };

    const isParentSelected = (option) => {
        if (option.requiresSubCategory) {
            return expandedGroup === option.key;
        }
        return selectedOption?.productGroup === option.key;
    };

    const isChildSelected = (child) =>
        selectedOption?.dealCategoryId === child.dealCategoryId;

    const handleNext = () => {
        if (!selectedOption?.dealCategoryId) return;

        navigate('/signup', {
            state: {
                signupType: {
                    productGroup: selectedOption.productGroup,
                    label: selectedOption.label,
                    dealCategoryId: selectedOption.dealCategoryId,
                    dealCategoryName: selectedOption.dealCategoryName,
                    requiresSubCategory: false,
                },
            },
        });
    };

    const dealTypeForm = (
        <div className="auth-signup-container">
            <div className="auth-header">
                <div className="logo">
                    <Image preview={false} src={Logo} alt="Logo" />
                </div>
                <BackButton />
                <Title level={3}>Select a Deal Type</Title>
                <Text className="signup-type-subtitle">
                    Select the funding option that suits your business.
                </Text>
            </div>
            <Flex vertical gap="middle" className='signup-type-cards-container'>
                {PRODUCT_GROUP_OPTIONS.map((option) => {
                    const parentSelected = isParentSelected(option);
                    const showChildren =
                        option.requiresSubCategory &&
                        expandedGroup === PRODUCT_GROUPS.FINANCING &&
                        option.key === PRODUCT_GROUPS.FINANCING;

                    return (
                        <div key={option.key} className="signup-type-option">
                            <Card
                                className={`signup-type-card ${parentSelected ? 'selected' : ''}`}
                                onClick={() => handleParentSelect(option)}
                            >
                                <Text style={{ fontWeight: parentSelected ? 'bold' : '400' }}>
                                    {option.label}
                                </Text>
                            </Card>

                            {showChildren && (
                                <Flex vertical gap="small" className="signup-type-children">
                                    {option.children.map((child) => {
                                        const childSelected = isChildSelected(child);
                                        return (
                                            <button
                                                key={child.key}
                                                type="button"
                                                className={`signup-type-radio-option ${childSelected ? 'selected' : ''}`}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleChildSelect(option, child);
                                                }}
                                            >
                                                <Radio checked={childSelected} tabIndex={-1} />
                                                <Text className="signup-type-radio-label">
                                                    {child.label}
                                                </Text>
                                            </button>
                                        );
                                    })}
                                </Flex>
                            )}
                        </div>
                    );
                })}
            </Flex>

            <CustomButton
                type="primary"
                style={{ padding: 24 }}
                block
                disabled={!selectedOption?.dealCategoryId}
                onClick={handleNext}
            >
                {BTN_TXT.NEXT}
            </CustomButton>
        </div>
    )

    return (
        <AuthDesign authForm={dealTypeForm} formType="enroll" />
    )
}

export default EnrollAs
